import React from 'react'
import { ChatMessageProps } from '../types'
import './ChatMessage.css'

const ChatMessage: React.FC<ChatMessageProps> = ({ message }) => {
  const isUser = message.role === 'user'

  const formatTime = (date: Date) => {
    const hours = date.getHours()
    const minutes = date.getMinutes()
    const ampm = hours >= 12 ? 'PM' : 'AM'
    const displayHours = hours % 12 || 12
    const displayMinutes = minutes.toString().padStart(2, '0')
    return `${displayHours}:${displayMinutes} ${ampm}`
  }

  // Convert newlines to line breaks for proper rendering
  const formatMessageContent = (content: string) => {
    return content.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        {line}
        {index < content.split('\n').length - 1 && <br />}
      </React.Fragment>
    ))
  }

  return (
    <div className={`message-container ${isUser ? 'user' : 'assistant'}`}>
      {!isUser && (
        <div className="ai-tag">
          Wonderschool AI
        </div>
      )}
      <div className={`message ${isUser ? 'user-message' : 'assistant-message'}`}>
        <div className="message-content">
          {formatMessageContent(message.content)}
        </div>
        <div className="message-time">
          {formatTime(message.timestamp)}
        </div>
      </div>
    </div>
  )
}

export default ChatMessage 